/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Reasons a calculated field is false.
 */
export enum FalseReason {
  GEOGRAPHY = 'geography',
  TIME_INSTALL_WINDOW = 'time_install_window',
  TIME_IN_HOME = 'time_in_home',
  OPS_OVERRIDE = 'ops_override',
  PREAPPROVAL = 'preapproval',
  ENROLLMENT = 'enrollment',
  NO_PROGRAMS = 'no_programs',
  NON_HTR = 'non_htr',
  PROGRAM_NOT_ACCEPTING_SUBMISSIONS = 'program_not_accepting_submissions',
  NO_ELECTRIC_PROVIDER = 'no_electric_provider',
  PROVIDERS = 'providers',
  NEW_HEATING_SOURCE_WITHIN_YEAR = 'new_heating_source_within_year',
  INVALID_HEATING_SOURCE = 'invalid_heating_source',
  SERVICES = 'services',
  SOLAR_INSTALLATION_WITHIN_YEAR = 'solar_installation_within_year',
  BUILDING_TYPE = 'building_type',
  EQUIPMENT_NOT_ELIGIBLE = 'equipment_not_eligible',
  INCOME_TOO_HIGH = 'income_too_high',
  EQUIPMENT_NOT_ENERGY_STAR_CERTIFIED = 'equipment_not_energy_star_certified',
  INSTALL_DATE = 'install_date',
  VENTURA_MARKET_RATE = 'ventura_market_rate',
  NO_HEATING_SOURCE = 'no_heating_source',
  INVALID_EQUIPMENT_LEFT_IN_PLACE = 'invalid_equipment_left_in_place',
  INVALID_POST_INSTALL_LOAD_SHARE = 'invalid_post_install_load_share',
  MULTIPLE_PRIMARY_SOURCES = 'multiple_primary_sources',
  GEOGRAPHY_DOES_NOT_HAVE_FUNDING = 'geography_does_not_have_funding',
}
